import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Doughnut } from 'react-chartjs-2'
import {
  useDispatch,
  // useSelector,
} from 'react-redux'
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Typography,
  colors,
  makeStyles,
  useTheme,
} from '@material-ui/core'
import {
  getAgesGroup,
  // selectorAgeGroup
} from '../../../app/slices/dashboardSlice'
// import LaptopMacIcon from '@material-ui/icons/LaptopMac'
// import PhoneIcon from '@material-ui/icons/Phone'
// import TabletIcon from '@material-ui/icons/Tablet'

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    borderRadius: '20px',
  },
}))

const TrafficByDevice = ({ className, ageGroup, ...rest }) => {
  const classes = useStyles()
  const theme = useTheme()
  const dispatch = useDispatch()
  const [agesArr, setAgesArr] = useState([])
  // const ageGroup = useSelector(selectorAgeGroup)

  useEffect(() => {
    dispatch(getAgesGroup())
  }, [])

  useEffect(() => {
    setAgesArr(ageGroup)
  }, [ageGroup])

  const sortedAges = agesArr?.slice().sort((a, b) => a.ageCategoryId - b.ageCategoryId)
  const ageCategoryCount = sortedAges?.map((item) => item?.ageCategoryCount)

  const ageLabels = ['گروه الف', 'گروه ب', 'گروه پ', 'گروه ت']

  console.log('ageCategoryCount', ageCategoryCount)
  console.log('sortedAges', sortedAges)

  const data = {
    datasets: [
      {
        data: ageCategoryCount,
        backgroundColor: [
          colors.indigo[500],
          colors.red[600],
          colors.orange[600],
          colors.green[600],
          // colors.pink[600],
          // colors.purple[600],
        ],
        borderWidth: 8,
        borderColor: colors.common.white,
        hoverBorderColor: colors.common.white,
      },
    ],
    labels: ['گروه الف', 'گروه ب', 'گروه پ', 'گروه ت'],
  }

  const options = {
    animation: false,
    cutoutPercentage: 50,
    layout: { padding: 0 },
    legend: {
      display: false,
    },
    maintainAspectRatio: false,
    responsive: true,
    tooltips: {
      backgroundColor: theme.palette.background.default,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: 'single',
      titleFontColor: theme.palette.text.primary,
    },
  }

  return (
    <Card
      className={clsx(classes.root, className)}
      {...rest}
    >
      <CardHeader title="گروه های سنی" />
      <Divider />
      <CardContent>
        <Box
          height={300}
          position="relative"
        >
          <Doughnut
            data={data}
            options={options}
          />
        </Box>
        <Box
          display="flex"
          justifyContent="center"
          mt={2}

        >
          {sortedAges?.map(({
            color,
            // icon: Icon,
            ageCategoryId,
            percentage,
          }) => {
            const labelAge = ageLabels?.find((item, index) => (index + 1) === +ageCategoryId)
            return (
              <Box
                key={ageCategoryId}
                p={1}
                textAlign="center"
              >
                {/* <Icon color="action" /> */}
                <Typography
                  color="textPrimary"
                  variant="body1"
                  style={{ width: '90%', whiteSpace: 'nowrap', marginBottom: '10px' }}
                >
                  {labelAge}
                </Typography>
                <Typography
                  style={{ color }}
                  variant="h4"
                >
                  %
                  {percentage?.toFixed()}

                </Typography>
              </Box>
            )
          })}
        </Box>
      </CardContent>
    </Card>
  )
}

TrafficByDevice.propTypes = {
  className: PropTypes.string,
}

export default TrafficByDevice
